<template>
	<v-container v-if="!loading">
		<v-row class="justify-center">
			<v-col
				cols="12"
				lg="7"
			>
				<invoice-information
					:amount="data.amount"
					:invoice-number="data.invoiceNumber"
					:policy-number="data.policyNumber"
					:device-name="data.deviceName"
					:product-name="data.productName"
				/>
			</v-col>
		</v-row>
		<div v-if="!isPaid">
			<v-row class="justify-center">
				<v-col
					cols="12"
					lg="7"
				>
					<adyen-payment
						:invoice-id="invoiceId"
						:token="token"
						:redirect-result="redirectResult"
						:session-id="sessionId"
					/>
				</v-col>
			</v-row>
			<v-row
				v-if="!redirectResult && !sessionId && (data.invoiceType !== 'Prepayment')"
				class="justify-center"
			>
				<v-col
					cols="12"
					lg="7"
				>
					<bank-transfer-card
						:invoice-identifier="data.invoiceNumber"
						:iban-number="data.companyIban"
					/>
				</v-col>
			</v-row>
		</div>
		<v-row
			v-else
			class="justify-center"
		>
			<v-col
				cols="12"
				lg="6"
			>
				<adyen-success-card />
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import {
	axios,
} from '../../services/axios-service';

export default {
	name: 'AdyenOverview',
	props: {
		token: {
			required: false,
			default: '',
			type: String,
		},
		invoiceId: {
			required: true,
			type: Number,
		},
		isPaid: {
			required: true,
			type: Boolean
		}
	},

	data () {
		return {
			data: null,
			isRedirect: false,
			sessionId: '',
			redirectResult: '',
			loading: true
		};
	},

	async mounted () {

		await this.getData();
		const uri = window.location.search.substring(1);
		const params = new URLSearchParams(uri);

		this.sessionId = params.get('sessionId') ? params.get('sessionId') : '';
		this.redirectResult = params.get('redirectResult') ? params.get('redirectResult') : '';
		this.amount = params.get('amount') ? params.get('amount') : '';
		this.loading = false;
	},


	methods: {
		/**
		 * @returns {void}
		 */
		async getData () {
			const eurFormatter = new Intl.NumberFormat('en-US', {
				style: 'currency',
				currency: 'EUR',
			});


			await axios.get(`api/v1/adyen/data?token=${this.token}&invoice_id=${this.invoiceId}`)
				.then(({
					data
				}) => {
					this.data = data;
					this.data.amount = (this.amount && !this.data.amount) ? eurFormatter.format(this.amount) : eurFormatter.format(this.data.amount);
				});
		},
	}
};
</script>

<style scoped>

</style>
